import { createContext, FC, useState } from 'react'

export type Data = {
  id?: string
  title: string
  description: string
  category: string
  cycle: string,
  url: string
  image?: File
  active: boolean
}
export interface DataContext {
  formData: Data,
  handleChangeFormData: (data: Partial<Data>) => void,
  handleUpdateFormData: (data: Partial<Data>) => void,
}

const initialData: Data = {
  id: '',
  title: '',
  description: '',
  category: '',
  cycle: '',
  url: '',
  image: undefined,
  active: true,
}

export const Context = createContext<DataContext>({
  formData: initialData,
  handleChangeFormData: (data: Partial<Data>) => {},
  handleUpdateFormData: (data: Partial<Data>) => { },
})

const NewFormDataProvider: FC = (props) => {
  const [formData, setFormData] = useState<Data>(initialData)

  const handleChangeFormData = (data: Partial<Data>) =>
      setFormData({ ...formData, ...data })

  const handleUpdateFormData = (data: Partial<Data>) => {
    if (data && data?.id) {
      setFormData({
        ...formData,
        id: data.id,
        title: data.title || initialData.title,
        description: data.description || initialData.description,
        category: data.category || initialData.category,
        cycle: data.cycle || initialData.cycle,
        url: data.url || initialData.url,
        image: data.image || initialData.image,
        active: data.active || false
      })
    }
  }
  return (
    <Context.Provider value={{ formData, handleChangeFormData, handleUpdateFormData }}>
      {props.children}
    </Context.Provider>
  )
}

export default NewFormDataProvider
